import { useEffect } from 'react'
import { OG_IMAGE_URL, SITE_URL, upsertLink, upsertMeta, upsertJsonLd, removeJsonLd, breadcrumbJsonLd } from './useSeo'

const BREADCRUMB_ID = 'staedte-ertrag-ranking-breadcrumb'
const TITLE = 'Photovoltaik-Ertrag: Ranking der 250 größten deutschen Städte | Roofora'
const DESCRIPTION =
  'Wo lohnt sich Photovoltaik am meisten? Ranking der 250 einwohnerstärksten deutschen Städte nach ' +
  'PV-Jahresertrag pro kWp (PVGIS-Daten, Süd-Ausrichtung/35° Referenzwert) - mit direktem Vergleich ' +
  'zum Bundesdurchschnitt.'

/** SEO tags for the DE-only /photovoltaik-ertrag-staedte-ranking hub page (SEO-4.0-Story Task 08)
 *  - same static, German-only pattern as usePvRechnerSeo (the page itself carries no i18n content,
 *  see the task doc's DE-only decision). Deliberately no FAQPage/ItemList JSON-LD here (unlike the
 *  250 individual city pages via useLandingPageSeo) - keeps scope to what the existing SEO
 *  primitives already cover; a future task can add it if warranted. */
export function useStaedteErtragRankingSeo() {
  useEffect(() => {
    document.documentElement.lang = 'de'
    const canonicalUrl = `${SITE_URL}/photovoltaik-ertrag-staedte-ranking`

    document.title = TITLE
    upsertMeta('name', 'description', DESCRIPTION)
    upsertMeta('property', 'og:title', TITLE)
    upsertMeta('property', 'og:description', DESCRIPTION)
    upsertMeta('property', 'og:url', canonicalUrl)
    upsertMeta('property', 'og:image', OG_IMAGE_URL)
    upsertMeta('name', 'twitter:title', TITLE)
    upsertMeta('name', 'twitter:description', DESCRIPTION)
    upsertMeta('name', 'twitter:image', OG_IMAGE_URL)
    upsertLink('canonical', canonicalUrl)

    upsertJsonLd(
      BREADCRUMB_ID,
      breadcrumbJsonLd([
        { name: 'Roofora', url: `${SITE_URL}/de` },
        { name: 'Photovoltaik-Ertrag Städte-Ranking', url: canonicalUrl },
      ]),
    )

    return () => removeJsonLd(BREADCRUMB_ID)
  }, [])
}
